import React, { useEffect, useContext, useState } from "react";
import Residence from "../Components/Residence";
import Spinner from "react-bootstrap/Spinner";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import { useParams } from "react-router-dom";
import { FaFileExcel } from "react-icons/fa";

function PaymentsReport() {
  const [residences, setResidences] = useState();
  const [manualPaymentsTotal, setManualPaymentsTotal] = useState();
  const [creditCardPaymentsTotal, setCreditCardPaymentsTotal] = useState();
  const [total, setTotal] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [downloadUrl, setDownloadUrl] = useState("");

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  useEffect(() => {
    async function fetch() {
      const result = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/residences/payments/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setResidences(result.data.residences);
      setTotal(result.data.total);
      setManualPaymentsTotal(result.data.manualPaymentsTotal);
      setCreditCardPaymentsTotal(result.data.creditCardPaymentsTotal);
      setIsLoading(false);
    }
    fetch();
  }, [rid, state.token]);

  const handleDownloadReport = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/reports/residences/download/payments/${rid}`,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    setDownloadUrl(response.data.url);
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Col>
        <Spinner animation="border" className="mb-2" />
        <h4>Procesando... Puede tardar algunos minutos, favor de esperar.</h4>
      </Col>
    );
  } else {
    return (
      <Col className="residences">
        <Col className="residences-header">
          <Row className="align-items-center">
            <Col lg={9} className="mb-2">
              <h4>Pagos registrados</h4>
            </Col>
            <Col lg={3} className="right icon mb-2">
              <FaFileExcel onClick={() => handleDownloadReport()} />
            </Col>
          </Row>
          {downloadUrl === "" ? (
            <></>
          ) : (
            <Row>
              <Col className="mb-3">
                <Alert variant="success">
                  Tu reporte ha sido generado con éxito.{" "}
                  <Alert.Link href={downloadUrl}>Descargar reporte.</Alert.Link>
                  .
                </Alert>
              </Col>
            </Row>
          )}
        </Col>
        <Col className="residences-content mb-3">
          <Col>
            <Row className="align-items-center">
              <Col lg={6}>
                <h6>Dirección</h6>
              </Col>
              <Col lg={2}>
                <p>Pagos efectivo</p>
              </Col>
              <Col lg={2}>
                <p>Pagos tarjeta</p>
              </Col>
              <Col lg={2}>
                <p>Suma de pagos</p>
              </Col>
            </Row>
          </Col>
          {residences.map((item) => (
            <Residence
              address={item.address}
              manualPayments={item.manualPayments}
              cardPayments={item.cardPayments}
              total={item.total}
              id={item._id}
              key={item._id}
            />
          ))}
        </Col>
        <Col className="residences-total">
          <Row>
            <Col lg={6}>
              <h5>Totales</h5>
            </Col>
            <Col lg={2}>
              <p>${manualPaymentsTotal}</p>
            </Col>
            <Col lg={2}>
              <p>${creditCardPaymentsTotal}</p>
            </Col>
            <Col lg={2}>
              <p>${total}</p>
            </Col>
          </Row>
        </Col>
      </Col>
    );
  }
}

export default PaymentsReport;
